import { MenuItem, Select, Box, SwipeableDrawer, Input } from "@mui/material";
import React, { Fragment, useCallback, useEffect, useState } from "react";
import { PROPOSAL_STATUS, PROPOSAL_TYPE } from "../../utils/constants";
import { toJS } from "mobx";
import { inject, observer } from "mobx-react";

const SearchAdvance = ({
  openSearchAdvance,
  handleOpenSearchAdvance,
  handleCloseSearchAdvance,
  filter,
  setFilter,
  arrSubmissionMenu,
  proposalStore,
}) => {
  const [keyword, setKeyword] = useState(undefined);
  const [type, setType] = useState();
  const [status, setStatus] = useState();

  const handleChangeStatus = (event) => {
    setStatus(event.target.value);
  };
  const handleChangeType = (event) => {
    setType(event.target.value);
  };

  const handleApply = () => {
    setFilter({
      page: 0,
      size: 10,
      ...filter,
      keyword: keyword,
      type: type,
      proposal_status: status,
    });
    proposalStore.setQueryParams({
      ...proposalStore.defaultQueryParams,
      page: 0,
      size: 10,
    });
    handleCloseSearchAdvance();
  };
  const handleReset = () => {
    setFilter({
      page: 0,
      size: 10,
      keyword: undefined,
      proposal_status: undefined,
      type: undefined,
      proposal_permission: undefined,
    });
    proposalStore.setQueryParams({
      ...proposalStore.defaultQueryParams,
      page: 0,
      size: 10,
    });
    setStatus();
    setType();
    setKeyword("");
  };
  const list = (
    <>
      <Box
        sx={{
          width: "335px",
          pt: "50px",
          minHeight: "500px",
          "& ul": {
            position: "unset",
            marginBottom: "70px",
          },
        }}
        role="presentation"
      >
        <div className="px-5 mt-[50px] search-advance">
          <div className="min-h-[calc(100vh-90px)]">
            <p className="font-semibold text-sm leading-5 text-[#16192C] mb-2">
              Tìm kiếm
            </p>
            <Input
              className="w-full border border-blue-400 rounded-md pl-4 text-sm py-1"
              placeholder="Tìm kiếm theo tiêu đề"
              type="search"
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              onBlur={() => setKeyword(keyword.trim())}
              disableUnderline
            />
            <p className="font-semibold text-sm leading-5 text-[#16192C] mt-6 mb-1">
              Loại
            </p>
            <div>
              <Select
                displayEmpty
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={type || ""}
                onChange={handleChangeType}
                fullWidth
              >
                <MenuItem value="" disabled>
                  <span style={{ color: "lightgray" }}>Lọc theo loại</span>
                </MenuItem>
                {arrSubmissionMenu?.map((item) =>
                  item?.child?.map((items) => (
                    <MenuItem value={items.id_child}>
                      <span>{items.name_child}</span>
                    </MenuItem>
                  ))
                )}
              </Select>
            </div>
            <p className="font-semibold text-sm leading-5 text-[#16192C] mt-6 mb-1">
              Trạng thái
            </p>
            <div>
              <Select
                displayEmpty
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={status || ""}
                onChange={handleChangeStatus}
                fullWidth
              >
                <MenuItem value="" disabled>
                  <span style={{ color: "lightgray" }}>
                    Lọc theo trạng thái
                  </span>
                </MenuItem>
                <MenuItem value={PROPOSAL_STATUS.PENDING}>
                  Chờ phê duyệt
                </MenuItem>
                <MenuItem value={PROPOSAL_STATUS.APPROVAL}>
                  Đã phê duyệt
                </MenuItem>
                <MenuItem value={PROPOSAL_STATUS.REJECT}>Từ chối</MenuItem>
              </Select>
            </div>
          </div>
        </div>
      </Box>
      <div className="fixed flex bottom-0 w-[335px] bg-white h-20 p-4">
        <button
          onClick={handleReset}
          className="text-center border-[1px] border-primary rounded text-primary w-1/2 py-[12px] mr-[5px]"
        >
          <div className="font-semibold text-[14px] leading-[22px] px">
            Nhập lại
          </div>
        </button>
        <button
          onClick={handleApply}
          className="text-center w-1/2 border-[1px] block text-white rounded bg-primary py-[12px] ml-[5px]"
        >
          <div className="font-semibold text-[14px] leading-[22px] px">
            Áp dụng
          </div>
        </button>
      </div>
    </>
  );
  return (
    <Fragment>
      <SwipeableDrawer
        anchor={"right"}
        open={openSearchAdvance}
        onOpen={handleOpenSearchAdvance}
        onClose={handleCloseSearchAdvance}
        disableSwipeToOpen={false}
      >
        {list}
      </SwipeableDrawer>
    </Fragment>
  );
};

export default inject("proposalStore")(observer(SearchAdvance));
